export default __webpack_public_path__ + "static/media/Bilo2-1.a580c476.jpg";